import CartStikyHeaderPresenter from "../components/cart-sticky-header/presenter/cart-sticky-header.js";

const footerElement = document.querySelector(`.footer`);
const cartStickyHeaderPresenter = new CartStikyHeaderPresenter({
  footerElement
});
cartStickyHeaderPresenter.init();
